<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="6">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>Acceder al Sistema de Almacén</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="alias"
                    label="Alias"
                    prepend-icon="person"
                    type="text"
                    required
                  />
                  <v-text-field
                    v-model="email"
                    autofocus
                    autocomplete="username"
                    label="Email"
                    prepend-icon="mail"
                    type="email"
                    required
                  />
                  <v-text-field
                    v-model="password"
                    id="password"
                    v-on:keyup.13="entrar()"
                    label="Contraseña"
                    prepend-icon="lock"
                    type="password"
                    required
                  />
                </v-form>
                <v-flex class="red--text" v-if="msj_informativo">{{msj_informativo}}</v-flex>
              </v-card-text>
              <v-card-actions>
                <v-btn @click="recuperar()" color="primary">Recuperar Contraseña</v-btn>
                <v-spacer />
                <v-btn @click="entrar()" color="primary">Entrar</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>


<script>
import axios from "axios";

export default {
  data() {
    return {
      alias: "",
      email: "",
      password: "",
      msj_informativo: null
    };
  },
  methods: {
    entrar() {
      this.msj_informativo = "";
      let parametros = { email: this.email, password: this.password };
      if (this.alias) {
        parametros.alias = this.alias;
      }
      console.log("parametros", parametros);
      axios
        .post("usuario/login", parametros)
        .then(respuesta => {
          console.log("login");
          console.log("respuesta.data", respuesta.data);
          this.$store.dispatch("guardarToken", respuesta.data.tokenReturn);
          this.$router.push({ name: "home" });
        })
        .catch(error => {
          //console.log(eror);
          this.msj_informativo = null;
          if (error.response && error.response.data.message) {
            this.msj_informativo = error.response.data.message;
          } else {
            this.msj_informativo = "Ocurrió un error con el servidor.";
          }
        });
    },
    recuperar() {
      let parametros = { email: this.email};
      if (this.alias) {
        parametros.alias = this.alias;
      }
      axios
        .post("usuario/regenerarClave", parametros)
        .then(respuesta => {
          console.log("login");
          console.log("respuesta.data", respuesta.data);
          console.log("Contraseña generada");
          this.msj_informativo = "Revisa tu EMAIL";
        })
        .catch(error => {
          //console.log(eror);
          this.msj_informativo = null;
          if (error.response && error.response.data.message) {
            this.msj_informativo = error.response.data.message;
          } else {
            this.msj_informativo = "Ocurrió un error con el servidor.";
          }
        });
    }
  }
};
</script>

